import { useMemo } from "react";
import { formatTimeRu } from "../../../utils/appointmentLabels";
import { IconBell } from "../../ui/icons";
import {
  CALENDAR_GRID_HEIGHT_PX,
  CALENDAR_HOURS,
  sessionColor,
  sessionLabel,
} from "./calendarUtils";
import { eventBlockStyle, layoutDayEvents } from "./desktopCalendarLayout";
import md from "../common/manageDesktop.module.css";

const GRID_HEIGHT = CALENDAR_GRID_HEIGHT_PX;

export default function DesktopDayTimeGridView({
  day,
  sessions,
  groups,
  onOpenSession,
}) {
  const dayList = useMemo(
    () =>
      sessions
        .filter((sess) => sess.start_datetime?.slice(0, 10) === day)
        .sort(
          (a, b) =>
            new Date(a.start_datetime) - new Date(b.start_datetime),
        ),
    [sessions, day],
  );

  const layouts = useMemo(() => layoutDayEvents(dayList), [dayList]);

  return (
    <div className={md.desktopDayGridWrap}>
      <div className={md.desktopDayGridScroll}>
        <div
          className={md.desktopDayGrid}
          style={{ height: `${GRID_HEIGHT}px` }}
        >
          <div className={md.desktopDayTimeCol}>
            {CALENDAR_HOURS.map((hour) => (
              <div key={hour} className={md.desktopDayTimeLabel}>
                {String(hour).padStart(2, "0")}:00
              </div>
            ))}
            <div className={md.desktopDayTimeEnd}>24:00</div>
          </div>

          <div className={md.desktopDayEventsCol}>
            <div className={md.desktopDayHourLines} aria-hidden>
              {CALENDAR_HOURS.map((hour) => (
                <div key={hour} className={md.desktopDayHourLine} />
              ))}
            </div>

            <div className={md.desktopDayEventsLayer}>
              {layouts.map((item) => {
                const groupIdx = groups.findIndex(
                  (g) => g.id === item.sess.group?.id,
                );
                const color = sessionColor(item.sess, groupIdx);
                return (
                  <button
                    key={item.sess.id}
                    type="button"
                    className={md.desktopDayEvent}
                    style={{
                      ...eventBlockStyle(item, { hourStart: 0 }),
                      "--event-color": color,
                    }}
                    onClick={() => onOpenSession?.(item.sess)}
                  >
                    <span className={md.desktopDayEventInner}>
                      <span className={md.desktopDayEventTitleRow}>
                        <IconBell
                          width={14}
                          height={14}
                          className={md.desktopDayEventIcon}
                        />
                        <span className={md.desktopDayEventTitle}>
                          {sessionLabel(item.sess)}
                        </span>
                      </span>
                      <span className={md.desktopDayEventTime}>
                        {formatTimeRu(item.sess.start_datetime)}
                      </span>
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
